<template>
    <!-- Header -->
    <DxToolbar style="height: 56px" class="toolbar">
        <DxItem location="before" locate-in-menu="never">
            <template #default>
                <routerVue :breadcrumbsItems="breadcrumbsItems" />
            </template>
        </DxItem>
    </DxToolbar>
    <!-- Content -->
    <DxValidationGroup ref="formValidation">
        <div class="row pl-4 mt-2 align-center" style="height: 48px">
            <DxDateBox
                label="Từ ngày (*)"
                labelMode="floating"
                v-model="LocBaoCao.TuNgay"
                displayFormat="HH:mm:ss dd/MM/yyyy"
                type="datetime"
                dropDownButtonTemplate="customIcon"
                validationMessageMode="always"
                id="datebox_BCHoatDongCuaBenXe_TuNgay"
                class="datebox-baocao"
                :useMaskBehavior="true"
                stylingMode="outlined"
                :height="36"
                :width="240"
            >
                <DxValidator>
                    <DxRequiredRule message="Không được để trống!" />
                    <DxRangeRule
                        :max="MaxDate"
                        :message="$i18n.t('DefaultString.MaxDate')"
                    />
                    <DxRangeRule
                        :min="MinDate"
                        :message="$i18n.t('DefaultString.MinDate')"
                    />
                    <DxRangeRule
                        :max="LocBaoCao.DenNgay"
                        message="Từ ngày phải nhỏ hơn hoặc bằng đến ngày"
                    />
                    <DxCustomRule
                        :validationCallback="checkSoNgay"
                        message="Từ ngày đến ngày phải nhỏ hơn 365 ngày!"
                    />
                </DxValidator>
                <template #customIcon="{}">
                    <DxButton icon="mdi mdi-calendar" />
                </template>
            </DxDateBox>
            <DxDateBox
                label="Đến ngày (*)"
                labelMode="floating"
                v-model="LocBaoCao.DenNgay"
                displayFormat="HH:mm:ss dd/MM/yyyy"
                type="datetime"
                dropDownButtonTemplate="customIcon"
                validationMessageMode="always"
                id="datebox_BCHoatDongCuaBenXe_DenNgay"
                :useMaskBehavior="true"
                class="datebox-baocao ml-3"
                stylingMode="outlined"
                :height="36"
                :width="240"
            >
                <DxValidator>
                    <DxRequiredRule message="Không được để trống!" />
                    <DxRangeRule
                        :max="MaxDate"
                        :message="$i18n.t('DefaultString.MaxDate')"
                    />
                    <DxRangeRule
                        :min="MinDate"
                        :message="$i18n.t('DefaultString.MinDate')"
                    />
                    <DxRangeRule
                        :min="LocBaoCao.TuNgay"
                        message="Đến ngày phải lớn hơn hoặc bằng từ ngày"
                    />
                    <DxCustomRule
                        :validationCallback="checkSoNgay"
                        message="Từ ngày đến ngày phải nhỏ hơn 365 ngày!"
                    />
                </DxValidator>
                <template #customIcon="{}">
                    <DxButton icon="mdi mdi-calendar" />
                </template>
            </DxDateBox>
            <DxButton
                class="ml-3"
                :icon="$i18n.t('icon.search')"
                text="Lọc"
                :rtlEnabled="true"
                styling-mode="outlined"
                @click="getData()"
            />
        </div>
    </DxValidationGroup>

    <div class="row pl-4">
        <div class="xs12">
            <DxDataGrid
                id="gridContainer"
                class="table-page"
                :remote-operations="true"
                :show-borders="true"
                :data-source="DanhSachLichSuCapThe"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-row-lines="true"
                ref="DanhSachLichSuCapThe"
                :toolbar="{ visible: false }"
                :loadPanel="{ showIndicator: false, showPane: false, text: '' }"
                no-data-text="Không có dữ liệu!"
                height="calc(100vh - 56px - 56px)"
                @cellHoverChanged="onCellHoverChanged"
                @selection-changed="onSelectionChanged"
                :onEditorPreparing="onEditorPreparing"
                :onToolbarPreparing="onToolbarPreparing"
                :groupPanel="{ visible: 'auto' }"
                :stateStoring="{
                    enabled: true,
                    savingTimeout: 0,
                    storageKey: 'DanhSachLichSuCapThe',
                    type: 'localStorage',
                }"
            >
                <DxHeaderFilter :visible="true" :allow-search="true" />
                <DxFilterRow :visible="true" applyFilter="onClick" />
                <DxPaging :page-size="50" />
                <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                <DxColumnFixing :enabled="true" />
                <DxSelection
                    select-all-mode="allPages"
                    show-check-boxes-mode="always"
                    mode="multiple"
                />
                <DxColumn
                    data-field="TenNhanVien"
                    caption="Nhân viên"
                    :fixed="true"
                    width="200px"
                />
                <DxColumn data-field="TenDoanhNghiep" caption="Doanh nghiệp" />
                <DxColumn data-field="KyHieuThe" caption="Ký hiệu thẻ" />
                <DxColumn
                    data-field="MaThe"
                    caption="Mã thẻ"
                    alignment="left"
                />
                <DxColumn
                    data-field="NgayCapThe"
                    caption="Ngày cấp thẻ"
                    dataType="datetime"
                    format="HH:mm:ss dd/MM/yyyy"
                    alignment="center"
                />
                <DxColumn
                    data-field="NgaySuaCuoi"
                    caption="Thời gian hủy"
                    dataType="datetime"
                    format="HH:mm:ss dd/MM/yyyy"
                    alignment="center"
                />
                <DxColumn
                    data-field="LyDoHuy"
                    caption="Lý do hủy"
                    alignment="left"
                />
                <DxColumn
                    :width="200"
                    alignment="left"
                    data-field="TenTrangThai"
                    caption="Trạng thái"
                    :fixed="true"
                    fixedPosition="right"
                    cell-template="statusTemplate"
                />
                <template #statusTemplate="{ data }">
                    <span :style="{ color: data.data.MaMauTrangThai }">
                        {{ data.data.TenTrangThai }}
                    </span>
                </template>
                <DxSummary>
                    <DxTotalItem
                        column="TenNhanVien"
                        summary-type="count"
                        display-format="Tổng: {0}"
                        :show-in-group-footer="true"
                        :align-by-column="true"
                    />
                </DxSummary>
                <!-- Hover button -->
                <DxColumn
                    cssClass="column-button-hover"
                    data-field="Detail"
                    caption="Trạng thái"
                    width="1"
                    cell-template="buttons-cell"
                    :fixed="true"
                    fixedPosition="right"
                ></DxColumn>
                <template #buttons-cell="{ data }">
                    <div class="buttons"></div>
                </template>

                <DxToolbarGrid>
                    <DxItemGrid location="after" name="groupPanel" />
                    <DxItemGrid
                        location="before"
                        template="listButtonTemplate"
                    />
                    <DxItemGrid location="before" name="applyFilterButton" />
                    <DxItemGrid location="before" name="columnChooserButton" />
                    <DxItemGrid location="before" template="refreshTemplate" />
                </DxToolbarGrid>
                <template #listButtonTemplate>
                    <div class="row align-center">
                        <DxButton
                            type="normal"
                            icon="mdi mdi-reload"
                            styling-mode="contained"
                            hint="Tải lại"
                            class="mx-1"
                            @click="TaiLai"
                        />
                        <DxButton
                            type="normal"
                            icon="mdi mdi-file-excel"
                            styling-mode="contained"
                            class="mx-1"
                            hint="Xuất Excel"
                            @click="exportExcel"
                        />
                        <div
                            class="ml-2"
                            style="
                                width: 1px;
                                height: 24px;
                                background: #03a9f4;
                            "
                        ></div>
                    </div>
                </template>
                <template #refreshTemplate>
                    <div class="row">
                        <DxButton
                            type="default"
                            styling-mode="text"
                            icon="mdi mdi-refresh"
                            hint="Khôi phục cài đặt gốc của bảng"
                            @click="onStateResetClick()"
                        />
                    </div>
                </template>
            </DxDataGrid>
        </div>
    </div>

    <DxPopup
        v-if="ifPopupXacNhan"
        v-model:visible="PopupXacNhan"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-close-button="false"
        :show-title="false"
        :width="488"
        height="auto"
        @hidden="onHidden('PopupXacNhan')"
    >
        <PopupXacNhan :Params="ParamXacNhan" @click="XacNhan" />
    </DxPopup>
</template>

<script>
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import routerVue from "@sonphat/common-v1/components/router.vue";
import {
    DxValidationGroup,
    DxDateBox,
    DxValidator,
    DxButton,
    DxPopup,
} from "devextreme-vue";
import {
    DxRequiredRule,
    DxRangeRule,
    DxCustomRule,
} from "devextreme-vue/validator";
import { mapActions, mapState } from "vuex";
import PopupXacNhan from "@sonphat/common-v1/components/PopupXacNhan.vue";
import {
    DxDataGrid,
    DxColumn,
    DxSelection,
    DxFilterRow,
    DxHeaderFilter,
    DxSummary,
    DxPaging,
    DxTotalItem,
    DxColumnFixing,
    DxScrolling,
    DxToolbar as DxToolbarGrid,
    DxItem as DxItemGrid,
} from "devextreme-vue/data-grid";
export default {
    components: {
        DxValidationGroup,
        DxDateBox,
        DxValidator,
        DxRequiredRule,
        DxRangeRule,
        DxCustomRule,
        DxToolbar,
        DxItem,
        routerVue,
        DxButton,
        DxDataGrid,
        DxColumn,
        PopupXacNhan,
        DxPopup,
        DxSelection,
        DxFilterRow,
        DxSummary,
        DxTotalItem,
        DxColumnFixing,
        DxScrolling,
        DxToolbarGrid,
        DxItemGrid,
        DxHeaderFilter,
        DxPaging,
    },
    data() {
        return {
            MaxDate: this.$Helper.Common.getEndDay(
                new Date(this.$i18n.t("DefaultNumBer.MaxDate"))
            ),
            MinDate: this.$Helper.Common.getStartDay(
                new Date(this.$i18n.t("DefaultNumBer.MinDate"))
            ),
            NgungHoatDong: false,
            itemDangChon: null,
            DanhSachLichSuCapThe: [],
            PopupXacNhan: false,
            ifPopupXacNhan: false,
            KeyPopupXacNhan: null,
            ParamXacNhan: {
                WidthTitle: "90%",
                Title: "Bạn có chắc chắn muốn xóa thẻ kiểm soát đang chọn?",
                btnLeft: "HỦY",
                btnRight: "ĐỒNG Ý",
            },
            arrSelected: [],
            breadcrumbsItems: [
                {
                    text: "Báo cáo",
                    disabled: true,
                    to: "",
                },
                {
                    text: "Lịch sử cấp thẻ",
                    disabled: true,
                    to: "",
                },
            ],
            ifPopupThongTinTheKiemSoat: false,
            PopupThongTinTheKiemSoat: false,
            ifPopupSuaThongTinTheKiemSoat: false,
            PopupSuaThongTinTheKiemSoat: false,
        };
    },
    computed: {
        LocBaoCao: {
            get() {
                return this.$store.state.CapThe.LocBaoCao;
            },
            set(data) {
                this.$store.commit("CapThe/Set", {
                    key: "LocBaoCao",
                    data: data,
                });
            },
        },
    },
    methods: {
        hiddenPopup(name) {
            this[name] = false;
        },
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        async getData() {
            this.$refs.DanhSachLichSuCapThe?.instance.clearFilter();
            this.$refs.DanhSachLichSuCapThe?.instance.clearSelection();
            try {
                this.DanhSachLichSuCapThe = (
                    await this.$store.dispatch("CapThe/LayDanhSachLichSuCapThe")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        TaiLai() {
            this.getData();
        },
        onEditorPreparing(e) {
            this.$Helper.Common.FilterRowWhenEnter(e);
        },
        onToolbarPreparing(e) {
            e.toolbarOptions.visible = true;
        },
        onStateResetClick() {
            this.$refs.DanhSachLichSuCapThe.instance.state(null);
            setTimeout(() => {
                this.$refs.DanhSachLichSuCapThe.instance.clearFilter();
                this.$refs.DanhSachLichSuCapThe.instance.clearSelection();
                this.$refs.DanhSachLichSuCapThe.instance.clearSorting();
            }, 100);
        },
        onCellHoverChanged(e) {
            this.$Helper.Common.table({ Element: e, Buttons: true }).HoverRow();
        },
        onSelectionChanged(e) {
            this.arrSelected = e.selectedRowsData;
        },
        TaoMoiTheKiemSoat() {
            this.$store.commit("TheKiemSoat/Reset_ThongTinTheKiemSoat");
            this.showPopup("PopupThongTinTheKiemSoat");
        },
        SuaTheKiemSoat(e) {
            this.$store.commit("TheKiemSoat/Set", {
                key: "ThongTinTheKiemSoat",
                data: this.$Helper.Common.CloneData(e),
            });
            this.showPopup("PopupSuaThongTinTheKiemSoat");
        },
        exportExcel() {
            let init = {
                Element: this.$refs.DanhSachLichSuCapThe.instance,
                FileName: "DanhSachLichSuCapThe",
                WorkSheet: "Danh Sách",
            };
            this.$Helper.Common.excel(init).Export();
        },
        checkSoNgay() {
            let minus = this.LocBaoCao.DenNgay - this.LocBaoCao.TuNgay;
            return minus / 1000 / 60 / 60 / 24 < 365;
        },
    },
    created() {
        this.LocBaoCao.TuNgay = this.$Helper.Common.getStartMonth(new Date());
        this.LocBaoCao.DenNgay = this.$Helper.Common.getEndDay(new Date());
        this.getData();
    },
};
</script>

<style scoped></style>
